import { getAllGroups } from '../../services/GroupFormServices';

function normalizeParentId(parentId) {
  if (parentId === undefined || parentId === null || parentId === '' || parentId === 'primary') {
    return null;
  }
  return String(parentId);
}

function getGroupParentId(group) {
  if (group.parent_id) {
    return String(group.parent_id);
  }
  if (group.parent?.id) {
    return String(group.parent.id);
  }
  return null;
}

export function checkForDuplicateGroup(entityName, cookies, existingId, parentId) {
  const normalizedName = String(entityName || '').trim().toUpperCase();
  const normalizedParent = normalizeParentId(parentId);

  return getAllGroups(cookies).then((data) => {
    let isDuplicate = false;
    (data.accounts_grouping_list || []).forEach((group) => {
      const sameName = String(group.entity_name || '').trim().toUpperCase() === normalizedName;
      const sameParent = getGroupParentId(group) === normalizedParent;
      const notSelf = existingId == null || parseInt(existingId, 10) !== group.id;
      if (sameName && sameParent && notSelf) {
        isDuplicate = true;
      }
    });
    return isDuplicate;
  });
}

export function getGroupsForCategory(categoryName, cookies) {
  return new Promise((resolve) => {
    getAllGroups(cookies)
      .then((data) => {
        let filteredGroups = [];
        const groups = data?.accounts_grouping_list || [];

        const parentGroups = groups.filter((obj) => obj.entity_name === categoryName);

        if (parentGroups.length > 0) {
          const categoryId = parentGroups[0].id;
          filteredGroups = groups.filter((obj) => obj.parent?.id === categoryId);
        }

        resolve(filteredGroups);
      })
      .catch(() => resolve([]));
  });
}
